import { api } from '../../shared/lib/api';
import type { Caixa, MovimentoCaixa, MovimentoTipo, ResumoCaixa } from './types';

export const caixaApi = {
  atual: () => api.get<Caixa | null>('caixa/atual'),
  list: (status?: 'aberto' | 'fechado') =>
    api.get<Caixa[]>('caixa', status ? { status } : undefined),
  abrir: (body: { valor_abertura: number; observacao?: string }) =>
    api.post<Caixa>('caixa/abrir', body),
  fechar: (body: { valor_informado: number; observacao?: string }) =>
    api.post<Caixa>('caixa/fechar', body),
  movimento: (body: { tipo: MovimentoTipo; valor: number; motivo?: string }) =>
    api.post<MovimentoCaixa>('caixa/movimento', body),
  resumo: (id: string) => api.get<ResumoCaixa>(`caixa/${id}/resumo`),
};
